const SORTING_DISABLE_KEYS = ['off', false];
const hasSortingDisabledKey = (key) => {
  const formattedKey = typeof key === 'string' ? key.toLowerCase() : key;
  return SORTING_DISABLE_KEYS.some((keyP) => keyP === formattedKey);
};
const getSortingColumnsCount = (columns = []) => {
  let sortingColumnsCount = 0; let
    totalColumnsCount = 0;
  for (let i = 0; i < columns.length; i += 1) {
    const column = columns[i];
    if (!column?.field && column?.columns?.length > 0) {
      const partialCount = getSortingColumnsCount(column.columns);
      sortingColumnsCount += partialCount.sortingColumnsCount;
      totalColumnsCount += partialCount.totalColumnsCount;
    } else {
      const span = column?.colSpan || 1;
      sortingColumnsCount += hasSortingDisabledKey(column?.sortingFn) ? 0 : span;
      totalColumnsCount += span;
    }
  }
  return { totalColumnsCount, sortingColumnsCount };
};
export {
  hasSortingDisabledKey,
  getSortingColumnsCount,
};
